import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import GeneralBloc from "../../../bloc/general_bloc";
import LanguageBloc from "../../../bloc/language_bloc";
import Labels from "../../constant/labels";

pdfjs.GlobalWorkerOptions.workerSrc = `${GeneralBloc.getAssetsContextPath()}/assets/javascript/pdf.worker.js`;

export default function AllPagesPdfViewer(props) {
  const [numPages, setNumPages] = useState(null);
  const [pagesRendered, setPagesRendered] = useState(null);

  const styles = {
    page: {
      flexDirection: "row",
      backgroundColor: "#fff",
      width: "100%",
      orientation: "portrait",
    },
    view: {
      width: "100%",
      height: "100%",
      padding: 0,
      backgroundColor: "white",
    },
    image: {
      objectFit: "cover",
    },
    closeButton: {
      marginTop: "20px",
      padding: "10px 20px",
      backgroundColor: "rgb(218, 41, 28)",
      color: "#fff",
      fontWeight:"500",
      border: "none",
      cursor: "pointer",
      position: "absolute",
      right: "20px",
      borderRadius:"12px"
    },
    container: {
      position: "relative",
    },
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPagesRendered(0);
  }

  function onRenderSuccess() {
    setPagesRendered((prev) => prev + 1);
  }

  const { pdf } = props;
  const pagesRenderedPlusOne = Math.min(pagesRendered + 1, numPages);

  return props.mobile === true || (props.width && props.width <= 600) ? (
    <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
      {Array.from(new Array(pagesRenderedPlusOne), (el, index) => {
        const isCurrentlyRendering = pagesRenderedPlusOne === index + 1;
        const isLastPage = numPages === index + 1;
        const needsCallbackToRenderNextPage = isCurrentlyRendering && !isLastPage;

        return (
          <div key={`page_${index + 1}`} style={styles.container}>
            <Page
              renderMode="canvas"
              orientation="portrait"
              wrap={true}
              width={props.width || 400}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              style={styles.page}
              size="A4"
              onRenderSuccess={needsCallbackToRenderNextPage ? onRenderSuccess : null}
              onClick={()=>{
                if(isLastPage && (props.showClose==true)){
                  if (props.onClose) {
                    props.onClose();
                  }
                }
                
              }}
            />
            {isLastPage && (props.showClose==true) && (
              <button
                style={styles.closeButton}                
              >
                {
                  LanguageBloc.getEngOrBMText("Close","Tutup")
                }
              </button>
            )}
          </div>
        );
      })}
    </Document>
  ) : (
    <Document
      style={{ margin: "0px" }}
      file={pdf}
      options={{ workerSrc: "/pdf.worker.js" }}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={console.error}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <div key={`page_${index + 1}`} style={styles.container}>
          <Page
            renderMode="canvas"
            width="1200"
            margin="0px"
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            style={styles.page}
            size="A4"
            onClick={()=>{
              if(index + 1 === numPages && (props.showClose==true)){
                if (props.onClose) {
                  props.onClose();
                }
              }
              
            }}
          />
          {index + 1 === numPages && (props.showClose==true) && (
            <button
              style={styles.closeButton}              
            >
              {
                LanguageBloc.getEngOrBMText("Close","Tutup")
              }
            </button>
          )}
        </div>
      ))}
    </Document>
  );
}
